import { deepCopy } from '@/utils/deep-copy'
import { v4 as uuidv4 } from 'uuid'
export default {
  data() {
    return {
      isSelecting: false,
      hasMoved: false,
      dragOriginPlaceholder: null,
      lastSelectionRect: { x: 0, y: 0, width: 0, height: 0 },
      selectionRect: { x: 0, y: 0, width: 0, height: 0 },
      selectionStart: {
        x: 0,
        y: 0
      },
      selectedPlaceholders: [],
      copyElements: [],
      draggingGroup: [],
      pageOffsets: [],
      mousePosition: { x: 0, y: 0, page: 0 }
    }
  },
  methods: {
    handleSelectClick() {
      this.showSelect = !this.showSelect
      this.selectedPlaceholders = []
      this.lastSelectionRect = null
    },
    onContainerMouseDown(event) {
      if (this.draggingPlaceholder || this.draggingGroup.length > 0) {
        return
      }
      const clickedOnUI = event.target.closest('.pdf-ui-ignore')
      if (clickedOnUI) {
        return
      }
      if (event.button === 0) {
        this.selectedPlaceholders = []
        this.lastSelectionRect = null
      }
      if (event.button !== 0) return
      const container = this.$refs.pdfContainer
      const rect = container.getBoundingClientRect()
      this.selectionStart = {
        x: event.clientX - rect.left + container.scrollLeft,
        y: event.clientY - rect.top + container.scrollTop
      }
      this.isSelecting = false
      this.hasMoved = false
      document.addEventListener('mousemove', this.onContainerMouseMove)
      document.addEventListener('mouseup', this.onContainerMouseUp)
    },
    onContainerMouseMove(event) {
      this.updateMousePosition(event)

      if (this.hasMoved) {
        const container = this.$refs.pdfContainer
        const rect = container.getBoundingClientRect()
        const current = {
          x: event.clientX - rect.left + container.scrollLeft,
          y: event.clientY - rect.top + container.scrollTop
        }
        const x = Math.min(this.selectionStart.x, current.x)
        const y = Math.min(this.selectionStart.y, current.y)
        this.selectionRect = {
          x,
          y,
          width: Math.abs(current.x - this.selectionStart.x),
          height: Math.abs(current.y - this.selectionStart.y)
        }
        return
      }
      const dx = Math.abs(event.clientX - this.selectionStart.x - this.$refs.pdfContainer.scrollLeft)
      const dy = Math.abs(event.clientY - this.selectionStart.y - this.$refs.pdfContainer.scrollTop)
      if (dx > 3 || dy > 3) {
        this.hasMoved = true
        this.isSelecting = true
        this.selectedPlaceholders = []
        this.lastSelectionRect = null
      }
    },
    updateMousePosition(event) {
      const container = this.$refs.pdfContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      const scrollX = container.scrollLeft
      const scrollY = container.scrollTop

      const mouseX = event.clientX - rect.left + scrollX
      const mouseY = event.clientY - rect.top + scrollY

      let currentPage = 0
      let cumulativeHeight = 0

      for (let i = 0; i < this.pageOffsets.length; i++) {
        const pageHeight = this.pageOffsets[i + 1]
          ? this.pageOffsets[i + 1] - this.pageOffsets[i]
          : this.$refs[`page_${i + 1}`]?.[0]?.offsetHeight || 0

        if (mouseY >= cumulativeHeight && mouseY < cumulativeHeight + pageHeight) {
          currentPage = i
          break
        }
        cumulativeHeight += pageHeight
      }

      this.mousePosition = {
        x: mouseX,
        y: mouseY,
        page: currentPage
      }
    },
    onContainerMouseUp() {
      document.removeEventListener('mousemove', this.onContainerMouseMove)
      document.removeEventListener('mouseup', this.onContainerMouseUp)
      if (this.hasMoved && this.isSelecting) {
        this.selectedPlaceholders = this.selectPlaceholdersInRect()
        this.lastSelectionRect = { ...this.selectionRect }
      }
      this.isSelecting = false
      this.hasMoved = false
      this.selectionRect = { x: 0, y: 0, width: 0, height: 0 }
    },
    rectsIntersect(r1, r2) {
      return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y)
    },
    selectPlaceholdersInRect() {
      const selected = []
      const container = this.$refs.pdfContainer
      if (!container) return selected
      const containerRect = container.getBoundingClientRect()
      this.placeholders.forEach(ph => {
        const el = this.$el.querySelector(`.placeholder[data-id="${ph.id}"]`)
        if (!el) return
        const elRect = el.getBoundingClientRect()
        const phRect = {
          x: elRect.left - containerRect.left + container.scrollLeft,
          y: elRect.top - containerRect.top + container.scrollTop,
          width: elRect.width,
          height: elRect.height
        }
        if (this.rectsIntersect(this.selectionRect, phRect)) {
          selected.push(ph.id)
        }
      })
      return selected
    },
    isSelected(id) {
      return this.selectedPlaceholders.includes(id)
    },
    copySelected() {
      if (this.selectedPlaceholders.length === 0) return
      this.copyElements = this.selectedPlaceholders.map(id => deepCopy(this.placeholders.find(p => p.id === id)))
      // НЕ сбрасываем выделение - нужно для Cut (Ctrl+X)
      this.closeMenu()
    },
    pasteElements(targetPosition = null) {
      if (!this.copyElements.length) return

      let targetPage, insertX, insertY

      if (targetPosition) {
        targetPage = this.menuPage
        const scale = this.pageScales[targetPage] || 1
        insertX = targetPosition.x / scale
        insertY = targetPosition.y / scale
      } else {
        targetPage = this.mousePosition.page
        const scale = this.pageScales[targetPage] || 1
        const pageTopOffset = this.pageOffsets[targetPage] || 0
        insertX = this.mousePosition.x / scale
        insertY = (this.mousePosition.y - pageTopOffset) / scale
      }

      const minX = Math.min(...this.copyElements.map(el => el.x))
      const minY = Math.min(...this.copyElements.map(el => el.y))

      this.copyElements.forEach(el => {
        const uuid = `placeholder_${uuidv4()}`
        this.placeholders.push({
          ...el,
          id: uuid,
          page: targetPage,
          x: insertX + (el.x - minX),
          y: insertY + (el.y - minY)
        })
      })
      this.saveToHistory()
      this.closeMenu()
    },
    startDrag(event, placeholder) {
      const isInputTarget = ['TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'BUTTON'].includes(event.target.tagName)
      const isContentEditable = event.target.isContentEditable
      if ((isInputTarget || isContentEditable) && !this.showDragging) {
        return
      }
      if (this.selectedPlaceholders.length > 0 && this.selectedPlaceholders.includes(placeholder.id)) {
        this.draggingPlaceholder = null
        this.draggingGroup = [...this.selectedPlaceholders]
      } else {
        this.selectedPlaceholders = [placeholder.id]
        this.draggingPlaceholder = placeholder
        this.draggingGroup = []
      }
      this.dragOriginPlaceholder = placeholder
      const scale = this.pageScales[placeholder.page] || 1
      const screenX = placeholder.x * scale
      const screenY = placeholder.y * scale
      this.draggingOffset = {
        x: event.clientX - screenX,
        y: event.clientY - screenY
      }
      this.lastSelectionRect = null
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },
    onDrag(event) {
      if (!this.draggingPlaceholder && !this.draggingGroup.length) return
      const originPh = this.dragOriginPlaceholder
      if (!originPh) return
      const targetPage = originPh.page
      const scale = this.pageScales[targetPage] || 1
      const newScreenX = event.clientX - this.draggingOffset.x
      const newScreenY = event.clientY - this.draggingOffset.y
      if (this.draggingGroup.length) {
        const initialScreenX = originPh.x * scale
        const initialScreenY = originPh.y * scale
        const deltaX = (newScreenX - initialScreenX) / scale
        const deltaY = (newScreenY - initialScreenY) / scale
        this.draggingGroup.forEach(id => {
          const ph = this.placeholders.find(p => p.id === id)
          if (ph) {
            ph.x += deltaX
            ph.y += deltaY
          }
        })
      } else if (this.draggingPlaceholder) {
        this.draggingPlaceholder.x = newScreenX / scale
        this.draggingPlaceholder.y = newScreenY / scale
      }
    },
    async stopDrag() {
      if (this.draggingPlaceholder || this.draggingGroup) {
        this.saveToHistory()
      }
      this.draggingGroup = []
      this.selectedPlaceholders = []
      this.draggingOffset = null
      this.dragOriginPlaceholder = null
      this.draggingPlaceholder = null
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    }
  },
  mounted() {
    this.$nextTick(() => {
      const container = this.$refs.pdfContainer
      if (container) {
        container.addEventListener('mousedown', this.onContainerMouseDown)
        container.addEventListener('mousemove', this.updateMousePosition)
      }
    })
  },
  beforeDestroy() {
    const container = this.$refs.pdfContainer
    if (container) {
      container.removeEventListener('mousedown', this.onContainerMouseDown)
      container.removeEventListener('mousemove', this.updateMousePosition)
    }
  }
}
